/**
 * RestoID — Enterprise SSO (enter work email).
 * ---------------------------------------------------------------------------
 * RestoID frame around `SsoEmailForm` — RestoID's own email field and CTA on the
 * PRISTINE upstream SSO logic (connector lookup + submit). Swapped in via
 * `src/App.tsx`.
 */
import { useTranslation } from 'react-i18next';

import FirstScreenLayout from '@/Layout/FirstScreenLayout';
import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';

import SsoEmailForm from '../components/SsoEmailForm';
import { ScreenHead, Stack } from '../components/restoid';
import { useCopy } from '../copy';

const SingleSignOnEmail = () => {
  const { t } = useTranslation();
  const c = useCopy();
  const navigate = useNavigateWithPreservedSearchParams();

  return (
    <FirstScreenLayout pageMeta={{ titleKey: 'action.single_sign_on' }}>
      <Stack gap={22}>
        <ScreenHead
          back={() => navigate(-1)}
          backLabel={c('backShort')}
          title={t('action.single_sign_on')}
          sub={t('description.single_sign_on_email_form')}
        />
        <SsoEmailForm />
      </Stack>
    </FirstScreenLayout>
  );
};

export default SingleSignOnEmail;
